import { View } from "extensions/marionette";

import strings from "common/strings";

import { Dropdown } from "common/components/dropdown/dropdown";
import { references } from "common/helpers/references";

import template from "./saveDialogContent.jst";
import "./saveDialogContent.scss";

export const SaveDialogContent = View.extend({
    className: "save-dialog-content",
    template,
    regions: {
        existingFilters: ".existing-filters"
    },
    
    events: {
        "change input[type=radio][name=saveto]": function(event) {
            if (event.target.value === "new") {
                this.state.existingFilterId = void 0;
                this.state.saveToNewFilter = true;
            } else if (event.target.value === "existing") {
                this.state.saveToNewFilter = false;
            } else {
                throw new Error(`Unknown value ${event.target.value}`);
            }
    
            this.render();
        },
        
        "keypress #name": function(e) {
            if (e.which === 13) {
                e.preventDefault();
                this.submitForm();
            }
        },
        
        submit(e) {
            e.preventDefault();
            this.submitForm();
        }
    },
    
    initialize() {
        this.state = {
            existingFilterId: void 0,
            saveToNewFilter: true,
            violations: []
        };
    },
    
    submitForm() {
        this.getOption("parent").getOption("buttons").find(({ role }) => role === "primary").onClick();
    },
    
    templateContext() {
        return {
            qualifiers: this.getOption("qualifiers").toTokens().map((t) => ({
                operator: t.operator,
                value: t.value,
                label: references.toAlias(t.ref, t.category)
            })),
            hasFilters: !!this.getOption("filters").length,
            state: this.state,
            stateClass: this.state.saveToNewFilter ? "new" : "existing"
        };
    },
    
    renderExistingFilters() {
        const filters = this.getOption("filters");
        if (filters.length) {
            this.showChildView("existingFilters", new Dropdown({
                // style: "style-link",
                collection: filters,
                collectionIdAttribute: "_id",
                showFilterInput: filters.length > 1,
                placeholder: strings.selectFilterPlaceholder,
                selected: this.state.existingFilterId,
                onChangeValue: (newValue) => {
                    this.state.existingFilterId = newValue;
                    this.state.saveToNewFilter = false;
                    this.render();
                }
            }));
        }
    },
    
    getNewFilterName() {
        return this.el.querySelector("#name").value.trim();
    },
    
    validate() {
        this.state.violations = [];
        if (this.state.saveToNewFilter && !this.getNewFilterName()) {
            this.state.violations.push(strings.filterNameRequiredError);
        }
        
        if (!this.state.saveToNewFilter && !this.state.existingFilterId) {
            this.state.violations.push(strings.existingFilterNameRequiredError);
        }
        
        if (this.state.violations.length) {
            this.render();
            return false;
        }
        
        return true;
    },
    
    onRender() {
        this.renderExistingFilters();
        this.focusNameInput();
    },
    
    focusNameInput() {
        this.el.querySelector("#name").focus();
    },
    
    onShown() {
        this.focusNameInput();
    }
});
